import { useEffect, useState } from "react";
import { Grid } from '@mui/material';

import AddEditDialog from "./AddEditDialog";
import NoteField from "../fields/NoteField";

interface DocumentArchiveListNoteDialogProps {
    isOpen: boolean;
    type: string;
    onCancel: () => void;
    onSave: (
        note: string
    ) => void;
}

const DocumentArchiveListNoteDialog: React.FC<DocumentArchiveListNoteDialogProps> = props => {
    const { isOpen, type, onCancel, onSave } = props;
    const [isDirty, setIsDirty] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [noteContent, setNoteContent] = useState('');
    
    
    useEffect(() => {
        if (!isOpen) {
            setDefaults();
        }
    }, [isOpen]);

    const setDefaults = () => {
        setIsDirty(false);
        setSubmitted(false);
        setNoteContent('');
    };

    const saveNote = () => {
        if (IsFormValid()) {
            setSubmitted(true);
            onSave(noteContent);
        }
    };

    const onError = () => {
        setSubmitted(false);
    }

    const IsFormValid = () => {
        // Using a regular expression to filter HTML tags since 
        // ReactQuill sets value to <p><br></p> when text is cleared manually
        let nonHtmlNoteValue = noteContent.replace(/<(.|\n)*?>/g, '').trim();

        return isDirty && nonHtmlNoteValue.length > 0;
    }

    const onNoteChange = (newValue: string) => {
        setIsDirty(true);
        setNoteContent(newValue);
    }

    return (
        <AddEditDialog
            isOpen={isOpen}
            isSubmitted={submitted}
            entityName={`${type} Details`}
            titlePrefix="Enter"
            saveButtonText={type}
            hideTitleCloseButton={true}
            onClose={onCancel}
            onSave={saveNote}
            validate={IsFormValid}
            onError={onError}
            maxWidth='md'
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <NoteField
                        value={noteContent}
                        placeholder={`Must enter a note before ${type}...`}
                        disabled={false}
                        onChange={onNoteChange}
                    />
                </Grid>
             </Grid>
        </AddEditDialog>
    );
}

export default DocumentArchiveListNoteDialog;